<template>
  <v-footer class="d-block w-100" :fixed="true">
    <div class="d-block text-center py-4 w-100">Bookshelf &copy; 2022-2023</div>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
  footer {
    flex: none;
  }
</style>
